/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TextsResponse } from '../../models/texts-response';

export interface GetApiPublicText$Params {

/**
 * 2 lower case letter locale
 */
  '_locale': 'de' | 'en' | 'fr';
}

export function getApiPublicText(http: HttpClient, rootUrl: string, params: GetApiPublicText$Params, context?: HttpContext): Observable<StrictHttpResponse<TextsResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiPublicText.PATH, 'get');
  if (params) {
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TextsResponse>;
    })
  );
}

getApiPublicText.PATH = '/api/public/{_locale}/texts';
